
<template>
	<div class="panel-main">
		<div class="panel-boss" v-if="lang=='en'">
			<h3>
				<Icon type="ios-cart-outline" size="16"></Icon>Label platform
			</h3>
			<article>
				<a target="_blank" :href="getUrl" class="panel-icon">
					<img src="../../image/icon_boss.png" alt />
				</a>
				<div>
					<a
						target="_blank"
						:href="getUrl"
						class="panel-title"
					>Label platform</a>
					<!-- <p>
						The platform based on cloud technology, no need to install and deploy, the cloud services security mechanism can provide customers with better products and services.
						The platform includes: product management, order management, purchase management, post-sales and perfect data analysis function. It can help companies to achieve one-stop, cross-platform, multi-store management. We strive to build efficient management methods and solutions.
					</p> -->
                    <p/>
					<a target="_blank" :href="getUrl">
						<Button type="primary" size="large">
							Enter
							<Icon type="arrow-right-c"></Icon>
						</Button>
					</a>
				</div>
			</article>
		</div>
		<div v-else>
			<h3>
				<Icon type="ios-cart" size="16"></Icon>Label系统
			</h3>
			<article>
				<a target="_blank" :href="getUrl" class="panel-icon">
					<img src="../../image/icon_boss.png" alt />
				</a>
				<div>
					<a target="_blank" :href="getUrl" class="panel-title">Label系统</a>
					<!-- <p>
						移动电子商务云服务平台基于云技术构建,无需安装部署,基于云服务的安全保障机制,为客户提供更好的产品与服务.
						<br />移动电子商务云服务平台包含:商品管理、订单管理、采购管理、售后、完善的数据分析等模块。帮助跨境公司实现一站式、跨平台、多店铺的管理，致力于打造高效的管理方法和解决方案。
					</p> -->
                    <p/>
					<a target="_blank" :href="getUrl">
						<Button type="primary" size="large">
							进入
							<Icon type="arrow-right-c"></Icon>
						</Button>
					</a>
				</div>
			</article>
		</div>
	</div>
</template>


<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState(['lang']),
		getUrl() {
			return this.handleHostname(`https://${global.envPrefix}tms.onepinnovate.com/#/home/`);
		}
	}
};

</script>
